export default __webpack_public_path__ + "js/components/common/unlock-button-font-pally/rocket-0b64bb2fc3e09207373e607ac4d6a334.svg";